export default __webpack_public_path__ + "static/media/organizar.72c91344.svg";